var $5fb5837f94e1c150$exports = {};
$5fb5837f94e1c150$exports = {
  "dragDescriptionKeyboard": "Paspauskite \u201EEnter\u201C, kad prad\u0117tum\u0117te vilkti.",
  "dragDescriptionKeyboardAlt": "Paspauskite \u201EAlt + Enter\u201C, kad prad\u0117tum\u0117te vilkti.",
  "dragDescriptionLongPress": "Palaikykite nuspaud\u0119, kad prad\u0117tum\u0117te vilkti.",
  "dragDescriptionTouch": "Palieskite dukart, kad prad\u0117tum\u0117te vilkti.",
  "dragDescriptionVirtual": "Spustel\u0117kite, kad prad\u0117tum\u0117te vilkti.",
  "dragItem": function dragItem(args) {
    return "Vilkti ".concat(args.itemText);
  },
  "dragSelectedItems": function dragSelectedItems(args, formatter) {
    return "Vilkti ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " pasirinkt\u0105 element\u0105");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " pasirinktus elementus");
      }
    }));
  },
  "dragSelectedKeyboard": function dragSelectedKeyboard(args, formatter) {
    return "Paspauskite \u201EEnter\u201C, jei norite nuvilkti ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " pasirinkt\u0105 element\u0105");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " pasirinktus elementus");
      }
    }), ".");
  },
  "dragSelectedKeyboardAlt": function dragSelectedKeyboardAlt(args, formatter) {
    return "Paspauskite \u201EAlt + Enter\u201C, kad nuvilktum\u0117te ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " pasirinkt\u0105 element\u0105");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " pasirinktus elementus");
      }
    }), ".");
  },
  "dragSelectedLongPress": function dragSelectedLongPress(args, formatter) {
    return "Nuspaud\u0119 palaikykite, kad nuvilktum\u0117te ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " pasirinkt\u0105 element\u0105");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " pasirinktus elementus");
      }
    }), ".");
  },
  "dragStartedKeyboard": "Prad\u0117ta vilkti. Paspauskite \u201ETab\u201C, kad pereitum\u0117te \u012F tiesiogin\u0119 paskirties viet\u0105, tada paspauskite \u201EEnter\u201C, kad numestum\u0117te, arba \u201EEscape\u201C, kad at\u0161auktum\u0117te.",
  "dragStartedTouch": "Prad\u0117ta vilkti. Eikite \u012F tiesiogin\u0119 paskirties viet\u0105, tada palieskite dukart, kad numestum\u0117te.",
  "dragStartedVirtual": "Prad\u0117ta vilkti. Eikite \u012F tiesiogin\u0119 paskirties viet\u0105 ir spustel\u0117kite arba paspauskite \u201EEnter\u201C, kad numestum\u0117te.",
  "dropCanceled": "Numetimas at\u0161auktas.",
  "dropComplete": "Numesta.",
  "dropDescriptionKeyboard": "Paspauskite \u201EEnter\u201C, kad numestum\u0117te. Paspauskite \u201EEscape\u201C, kad at\u0161auktum\u0117te vilkim\u0105.",
  "dropDescriptionTouch": "Palieskite dukart, kad numestum\u0117te.",
  "dropDescriptionVirtual": "Spustel\u0117kite, kad numestum\u0117te.",
  "dropIndicator": "numetimo indikatorius",
  "dropOnItem": function dropOnItem(args) {
    return "Numesti ant ".concat(args.itemText);
  },
  "dropOnRoot": "Numesti ant",
  "endDragKeyboard": "Velkama. Paspauskite \u201EEnter\u201C, kad at\u0161auktum\u0117te vilkim\u0105.",
  "endDragTouch": "Velkama. Spustel\u0117kite dukart, kad at\u0161auktum\u0117te vilkim\u0105.",
  "endDragVirtual": "Velkama. Spustel\u0117kite, kad at\u0161auktum\u0117te vilkim\u0105.",
  "insertAfter": function insertAfter(args) {
    return "\u012Eterpti po ".concat(args.itemText);
  },
  "insertBefore": function insertBefore(args) {
    return "\u012Eterpti prie\u0161 ".concat(args.itemText);
  },
  "insertBetween": function insertBetween(args) {
    return "\u012Eterpti tarp ".concat(args.beforeItemText, " ir ").concat(args.afterItemText);
  }
};
export { $5fb5837f94e1c150$exports as default };